import { FC } from 'react'

import {
  ActiveDay,
  BorderDay,
  DisabledDay,
  FlexibleDay,
  RangeDay,
  SelectedDay,
} from '.'

import { DateMonth } from '../month'

interface Props {
  day: DateMonth
  onClick?: (day: string) => void
}

export const RenderDay: FC<Props> = ({ day, onClick }) => {
  switch (day.type) {
    case 'border':
      return (
        <BorderDay
          {...day}
          onClick={onClick}
        />
      )
    case 'disabled':
      return <DisabledDay {...day} />
    case 'flexible':
      return (
        <FlexibleDay
          {...day}
          onClick={onClick}
        />
      )
    case 'range':
      return (
        <RangeDay
          {...day}
          onClick={onClick}
        />
      )
    case 'selected':
      return (
        <SelectedDay
          {...day}
          onClick={onClick}
        />
      )
    default:
      return (
        <ActiveDay
          {...day}
          onClick={onClick}
        />
      )
  }
}
